export function Sprite(img, x, y, width, height) {
  this.img = img;
  this.x = x * 2;
  this.y = y * 2;
  this.width = width * 2;
  this.height = height * 2;
}

export const drawSprite = (ctx, sprite, x, y) => {
  ctx.drawImage(
    sprite.img,
    sprite.x,
    sprite.y,
    sprite.width,
    sprite.height,
    x,
    y,
    sprite.width,
    sprite.height
  );
};

export const initSprites = (img) => {
  return {
    bird: [new Sprite(img, 156, 115, 17, 12)],
    bg: new Sprite(img, 0, 0, 138, 114),
    fg: new Sprite(img, 138, 0, 112, 56),
    pipeNorth: new Sprite(img, 251, 0, 26, 200),
    pipeSouth: new Sprite(img, 277, 0, 26, 200),
  };
};
